import React from 'react';
import { useFormikContext,  getIn } from "formik";
import { Button, FormGroup, Input, Row, Col,Label, Container } from "reactstrap";
import { FormLabel, FormValue } from '../../Form/FormLabel'
import SelectPlace from '../../Form/SelectPlace'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tabs'
import { useAuth } from '../../../Services/AuthContext';
import { useEffect } from 'react';
import { useState } from 'react';
import useFunction from '../../../utils/Hooks/useFunction';
import FormContainer from '../../Models/FormContainer';
import useFetch from '../../../Services/useFetch';
import { authEndpoints } from '../../../utils/Constants';
import AircraftTypes from '../../Form/AircraftTypes';
import FormInput from '../../Form/FormInput';
import { emailIndicitaveShapeYup, indicitavePriceShapeYup } from '../../../utils/YupShapes';
import LoadingAnimation from '../../Form/LoadingAnimation';


const RadioButtons = ({ id, options, label, initialValue }) => {
    const { setFieldValue } = useFormikContext();
    const [val, setVal] = useState(initialValue.name);
    const setValue = ( x) => {
        setVal(x);
        setFieldValue(id, x);

    };
    return <FormGroup tag="fieldset" row>
        {label ? <FormLabel>{label}</FormLabel> : null}
        {options?.map((x, i) => <Col key={i}>
            <FormGroup check>
                <Label check>
                    <Input type="radio" name={"radioId"} onChange={() => setValue( x.name)} checked={val===x.name} /> {' '}{x.value}
                </Label>
            </FormGroup>
        </Col>)}
    </FormGroup>
}

const ResultRow = ({index ,aircraft, values }) => {
    const { category, minPassenger, maxPassenger, speedRangeMin, speedRangeMax, hourlyRateRangeMin, hourlyRateRangeMax, maximunFlighTimePerDay } = aircraft;
    const {  distance } = values;
    const getHours = (value) => {
        const hours = parseInt(value);
        const minutes = String(parseInt((value - hours) * 60)).padStart(2,'0');
        return hours + ':' + minutes;

    }
    const rangeMin = speedRangeMin * maximunFlighTimePerDay / 60;
    const rangeMax = speedRangeMax * maximunFlighTimePerDay / 60;
    const outOfRange = rangeMin < distance && rangeMax < distance;
    return <div>
        {!index ? <Row >
            <Col>
                <FormLabel>Preference</FormLabel>

            </Col>
            <Col>
                <FormLabel>Passengers</FormLabel>
            </Col>
            <Col>
                <FormLabel>Speed (km/hr)</FormLabel>
            </Col>
            <Col>
                <FormLabel>Range (km)</FormLabel>
            </Col>
            <Col>
                <FormLabel>Flight Time</FormLabel>
            </Col>
            <Col>
                <FormLabel>Price Estimate ($AUD)</FormLabel>
            </Col>
        </Row> : null}
        <Row >
            <Col>
                <FormValue>{category}</FormValue>

            </Col>
            <Col>
                <FormValue>{minPassenger} - {maxPassenger}</FormValue>
            </Col>
            <Col>
                <FormValue>{speedRangeMin} - {speedRangeMax}</FormValue>
            </Col>
            <Col>
                <FormValue style={outOfRange ? { color: 'red' }:null}>{rangeMin}-{rangeMax+' '} </FormValue>
            </Col>
            <Col>
                {outOfRange ? null : <FormValue>{getHours(distance / speedRangeMin)} - {getHours(distance / speedRangeMax)}</FormValue>}
            </Col>
            <Col>
                {outOfRange ? null : <FormValue style={{ color: 'black' }}>${parseInt(hourlyRateRangeMin * distance / speedRangeMax).toLocaleString()}- ${parseInt(hourlyRateRangeMax * distance / speedRangeMin).toLocaleString()}</FormValue>}
            </Col>
        </Row>
        <Row>
            <Col>
            </Col>
        </Row>
    </div>
}

const IndicitavePriceDetail = ({ charterTypes, activeTab }) => {
    const { setFieldValue, values } = useFormikContext();
    const { from, to } = values;
    const handleChangePlace = (prefix, value) => {
        const fieldName = prefix;
        setFieldValue(fieldName, value.description);
        const stateIndex = value.types.findIndex(x => x === "locality");
        const state = stateIndex >= 0 ? value.terms[stateIndex]?.value : '';
      
        setFieldValue(fieldName + 'State', state);


    };
    const [fromGeo, setFromGeo] = useState(values.fromLatLong);
    const [toGeo, setToGeo] = useState(values.toLatLong);
    const [distance, setDistance] = useState();

    const onCoordsChanged = (id, a) => {
        id === 'to' ? setToGeo(a) : setFromGeo(a);
        
    };
    useEffect(() => {
        if (fromGeo && toGeo) {
            const from = new window.google.maps.LatLng(fromGeo.lat, fromGeo.lng);
            const to = new window.google.maps.LatLng(toGeo.lat, toGeo.lng);
            const distance = window.google.maps.geometry.spherical.computeDistanceBetween(from, to);
            setDistance(distance);
            setFieldValue('distance', distance/1000);
        }
    }, [fromGeo, toGeo,setFieldValue]);
    const placeSearch = {
        location: new window.google.maps.LatLng(-25.2744, 133.7751),
        radius: 200000,
        strictbounds: true,
        types: ['(cities)'],
        language: 'en-AU'
    };
    const options = [{ name: 'same', value: 'Same Day Return' }, { name: 'next', value: 'Next Day Return' }, { name: 'twoPlus', value: 'Returning 2+ Days Later' }];

    return (<Container style={{ paddingLeft: '15px',paddingRight: '15px', paddingTop: '15px', paddingBottom: '35px' }}>
        <Row >
            <Col>
                <FormLabel>From</FormLabel>
                <SelectPlace id={`from`} autocompletionRequest={placeSearch} name={`from`} onCoordsChanged={(a) => onCoordsChanged('from', a)} placeholder="From" value={from} onChange={(e) => handleChangePlace( 'from', e)} />
            </Col>
            <Col>
                <FormLabel>To</FormLabel>
                <SelectPlace id={`to`} autocompletionRequest={placeSearch} name={`to`} onCoordsChanged={(a) => onCoordsChanged('to', a)} placeholder="To" value={to} onChange={(e) => handleChangePlace('to', e)} />
            </Col>
        </Row>
        {distance ? <h6>Distance : {parseInt(distance / 1000)}KM</h6>:null}
        <Row >
            <Col>
                <AircraftTypes indicitave id='preferredAircraft' label='Preferred Aircraft' list={charterTypes} />
            </Col>
        </Row>
        {activeTab === 'Return' ? <Row>
            <Col>
                <RadioButtons options={options} initialValue={{ name: 'same' }}  id={'returnType'} />
            </Col>
        </Row> : null}  
    </Container>)

    
    
}

const newIndicitave = {
    from: '',
    to: '',
    email:'',
    preferredAircraft: '',
    distance:0}
const IndicitavePrice = ({ onClose }) => {
    const [handleSubmit, setHandleSubmit] = useFunction();
    const [submit, setSubmit] = useState(false);
    const [detail, setDetail1] = useState(newIndicitave);
    const [activeTab, setActiveTab] = useState("OneWay");
    const [auth] = useAuth(); 

    const setDetail = (e) => {
        setDetail1(e)
    }
    const doSubmit = (values) => {
        if (!values.loadEmail) {
            auth.role ? setDetail({ ...values, returnType: activeTab, loadEmail: true, results: true }):setDetail({ ...values, loadEmail: true, returnType: activeTab });
        }
        // postSubmit(url, "Saved ", values);
    }
    const doSubmit2 = (values) => {
        if (!values.results) {
            setDetail({ ...values, returnType: activeTab, results: true });
        }
        // postSubmit(url, "Saved ", values);
    }
    const [charterTypes] = useFetch(authEndpoints.getIndicitaveFlight);
    useEffect(() => { })
    const loadEmail = getIn(detail, 'loadEmail');
    const results = getIn(detail, 'results');
    const from = getIn(detail, 'from');
    const distance = getIn(detail, 'distance');
    const to = getIn(detail, 'to');
    const preferredAircraft = getIn(detail, 'preferredAircraft');
    return !loadEmail ? <FormContainer initialValues={detail} validationSchema={indicitavePriceShapeYup} edit={true} newRequest={false} setHandleSubmit={setHandleSubmit} onSubmit={doSubmit} setSubmitting={setSubmit}>
        <Container>
            {submit ? <LoadingAnimation/>:null}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'centre' }}>
                <img alt='jetbidders' src={'/img/logo.png'} style={{ width: '60%', height: 'auto', marginTop: '5vh' }} />
            </div>
            <FormLabel>Request Indicative Price</FormLabel>
            <h2>Flight Details</h2>

            <Tabs mountOnEnter className='charterTabParent' onSelect={setActiveTab} activeKey={activeTab} >
                <Tab tabClassName='charterTabItem' className={'charterTab'} key={'OneWay'} eventKey={'OneWay'} title='One Way' style={{ background: 'white', borderLeft: '1px solid black', borderRight: '1px solid black', borderBottom: '1px solid black' }}>
                    <IndicitavePriceDetail charterTypes={charterTypes} activeTab={activeTab} style={{ margin: '15px' }} />
                </Tab>
                <Tab tabClassName='charterTabItem' className={'charterTab'} key={'Return'} eventKey={'Return'} title='Return' style={{ background: 'white', borderLeft: '1px solid black', borderRight: '1px solid black', borderBottom: '1px solid black' }}>

                    <IndicitavePriceDetail charterTypes={charterTypes} activeTab={activeTab} style={{ margin: '15px' }} />

                </Tab>

            </Tabs>
            <Row >
                <Col>
                    <div style={{ marginTop: '25px', marginBottom: '50px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>

                        <Button color='secondary' type='button' onClick={onClose}  >Go Back</Button>
                        < Button color='primary' type='button' onClick={handleSubmit}>Continue</Button>

                    </div>
            '</Col>
            </Row>
        </Container>
    </FormContainer> : !results ? <FormContainer initialValues={detail} validationSchema={emailIndicitaveShapeYup} edit={true} newRequest={false} setHandleSubmit={setHandleSubmit} onSubmit={doSubmit2} setSubmitting={setSubmit}>
            <Container>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'centre' }}>
                    <img alt='jetbidders' src={'/img/logo.png'} style={{ width: '60%', height: 'auto', marginTop: '5vh' }} />
                </div>
            <Row >
                    <Col>

                    <FormLabel>About You</FormLabel>
                    <h2>Your Details</h2>
                    <FormInput id='email' type='email' label='Your Email' />
                </Col>
            </Row>
            <Row >
                <Col>
                    <div style={{ marginTop: '25px', marginBottom: '50px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                        <Button color='secondary' type='button' onClick={() => setDetail({ ...detail, loadEmail: null })}  >Go Back</Button>
                        < Button color='primary' type='button' onClick={handleSubmit}>Continue</Button>
                    </div>
            '</Col>
            </Row>
        </Container>
        </FormContainer> : <Container>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'centre' }}>
                    <img alt='jetbidders' src={'/img/logo.png'} style={{ width: '60%', height: 'auto', marginTop: '5vh' }} />
                </div>
                <Row >
                    <Col>
                      
                        <h2>Your Results</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormLabel>From</FormLabel>
                        <FormValue>{from}</FormValue>
                    </Col>
                    <Col>
                        <FormLabel>To</FormLabel>
                        <FormValue>{to}</FormValue>
                    </Col>
                    <Col>
                        <FormLabel>Distance</FormLabel>
                        <FormValue>{parseInt(distance).toLocaleString()} km</FormValue>
                    </Col>
                </Row>
                {preferredAircraft.map((x, i) => <ResultRow index={i} key={i} aircraft={x} values={detail} />)}
                <Row >
                    <Col>
                        <div style={{ marginTop: '25px', marginBottom: '50px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                            <Button color='secondary' type='button' onClick={() => auth.role ? setDetail({ ...detail, results: null,loadEmail:null }): setDetail({ ...detail, results: null })}  >Go Back</Button>
                            < Button color='primary' type='button' onClick={onClose}>Continue</Button>
                        </div>
            '</Col>
                </Row >
            </Container>

}

export default IndicitavePrice; 
